import { Icon } from '@chakra-ui/react';

export default function SlackIcon(props) {
  return (
    <Icon
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.66669 11.9474C6.66669 11.0736 7.32743 10.3701 8.14817 10.3701C8.96891 10.3701 9.62965 11.0736 9.62965 11.9474V15.8299C9.62965 16.7037 8.96891 17.4072 8.14817 17.4072C7.32743 17.4072 6.66669 16.7037 6.66669 15.8299V11.9474Z'
        fill='#E01E5A'
        stroke='#E01E5A'
        strokeWidth={0.296296}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9476 13.3331C11.0738 13.3331 10.3704 12.6723 10.3704 11.8516C10.3704 11.0309 11.0738 10.3701 11.9476 10.3701H15.8301C16.7039 10.3701 17.4074 11.0309 17.4074 11.8516C17.4074 12.6723 16.7039 13.3331 15.8301 13.3331H11.9476Z'
        fill='#ECB22D'
        stroke='#ECB22D'
        strokeWidth={0.296296}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.3704 4.17003C10.3704 3.29624 11.0311 2.59277 11.8518 2.59277C12.6726 2.59277 13.3333 3.29624 13.3333 4.17003V8.05253C13.3333 8.92635 12.6726 9.62981 11.8518 9.62981C11.0311 9.62981 10.3704 8.92635 10.3704 8.05253V4.17003Z'
        fill='#2FB67C'
        stroke='#2FB67C'
        strokeWidth={0.296296}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.16985 9.62995C3.29605 9.62995 2.59259 8.96921 2.59259 8.14847C2.59259 7.32773 3.29605 6.66699 4.16985 6.66699H8.05235C8.92616 6.66699 9.62963 7.32773 9.62963 8.14847C9.62963 8.96921 8.92616 9.62995 8.05235 9.62995H4.16985Z'
        fill='#36C5F1'
        stroke='#36C5F1'
        strokeWidth={0.296296}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.3703 15.9258C10.3699 16.1205 10.4079 16.3133 10.4822 16.4933C10.5565 16.6732 10.6657 16.8367 10.8033 16.9743C10.941 17.112 11.1044 17.2211 11.2844 17.2954C11.4643 17.3697 11.6571 17.4077 11.8518 17.4073C12.6725 17.4073 13.3333 16.7466 13.3333 15.9258C13.3337 15.7312 13.2957 15.5383 13.2214 15.3584C13.1471 15.1785 13.0379 15.015 12.9003 14.8773C12.7626 14.7397 12.5992 14.6306 12.4192 14.5563C12.2393 14.482 12.0465 14.4439 11.8518 14.4443H10.3703V15.9258Z'
        fill='#ECB22D'
        stroke='#ECB22D'
        strokeWidth={0.296296}
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.9259 9.62995H14.4444V8.14847C14.4444 7.32773 15.1051 6.66699 15.9259 6.66699C16.7466 6.66699 17.4074 7.32773 17.4074 8.14847C17.4074 8.96921 16.7466 9.62995 15.9259 9.62995Z'
        fill='#2FB67C'
        stroke='#2FB67C'
        strokeWidth={0.296296}
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.07403 10.3701H5.55551V11.8516C5.55551 12.6723 4.89477 13.3331 4.07403 13.3331C3.87936 13.3335 3.68653 13.2955 3.5066 13.2212C3.32667 13.1468 3.16319 13.0377 3.02554 12.9001C2.88789 12.7624 2.77878 12.599 2.70447 12.419C2.63017 12.2391 2.59213 12.0463 2.59255 11.8516C2.59255 11.0309 3.25329 10.3701 4.07403 10.3701Z'
        fill='#E01E5A'
        stroke='#E01E5A'
        strokeWidth={0.296296}
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.62958 4.07426V5.55574H8.1481C7.95343 5.55615 7.7606 5.51812 7.58067 5.44381C7.40074 5.36951 7.23726 5.2604 7.0996 5.12275C6.96195 4.9851 6.85284 4.82162 6.77854 4.64169C6.70424 4.46176 6.6662 4.26893 6.66661 4.07426C6.66661 3.25352 7.32735 2.59278 8.1481 2.59278C8.34276 2.59236 8.5356 2.6304 8.71552 2.7047C8.89545 2.77901 9.05893 2.88812 9.19659 3.02577C9.33424 3.16342 9.44335 3.3269 9.51765 3.50683C9.59195 3.68676 9.62999 3.87959 9.62958 4.07426Z'
        fill='#36C5F1'
        stroke='#36C5F1'
        strokeWidth={0.296296}
        strokeLinecap='round'
      />
    </Icon>
  );
}
